import { GrayColors } from "@smartsuite/types";
import styled from "styled-components";

export const Wrapper = styled.div`
  .monthday-text {
    top: 70px;
    position: relative;
    .medium {
      font-weight: 400;
    }
  }
`;

export const Pipe = styled.div`
  border-left: 1px solid ${GrayColors["G-1-5"]};
  height: 170px;
  margin-left: 15px;
  margin-right: 15px;
  top: 70px;
  padding-left: 8px;
  position: relative;
  max-width: calc(100% - 10px);
`;
